<script setup>
const asset = (path) => `${import.meta.env.BASE_URL}${path}`

const menuItems = [
  {
    icon: asset('page-menu/category-provider.svg'),
    label: 'Providers',
  },
  {
    icon: asset('page-menu/main.svg'),
    label: 'Games',
  },
  {
    icon: asset('page-menu/star.svg'),
    label: 'Top',
  },
]
</script>

<template>
  <section class="page-menu" aria-label="Game menu">
    <button v-for="item in menuItems" :key="item.label" class="page-menu__item" type="button">
      <img :src="item.icon" alt="" aria-hidden="true" />
      <span>{{ item.label }}</span>
    </button>
  </section>
</template>

<style scoped>
.page-menu {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  width: min(100%, 1280px);
  margin: 0 auto;
  padding: 20px 12px 28px;
  
}

.page-menu__item {
  display: flex;
  min-height: 76px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  color: #fff;
  background:
    var(--gradient-background) padding-box,
    var(--gradient-border) border-box;
  text-transform: uppercase;
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.page-menu__item:hover {
  background:
    var(--gradient-background-hover) padding-box,
    var(--gradient-border-hover) border-box;
  box-shadow: var(--shadow-control-hover);
}

.page-menu__item img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.page-menu__item span {
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1;
}

@media (min-width: 768px) {
  .page-menu {
    grid-template-columns: repeat(3, 154px);
    justify-content: start;
    gap: 22px;
    padding: 32px 48px 40px;
  }

  .page-menu__item {
    min-height: 78px;
    gap: 8px;
    padding: 12px 18px;
  }

  .page-menu__item img {
    width: 25px;
    height: 25px;
  }

  .page-menu__item span {
    font-size: 1rem;
  }
}
</style>
